var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Table, Container, Card } from 'reactstrap';
import { injectIntl } from "react-intl";
import { ApplicationContext } from '../../../ApplicationContext';
import AssetCollection from '../../../collections/assets/AssetCollection';
import { EmptyTableRow } from '../../components/ui/EmptyRow/EmptyRow';
import TableHeaderColumn from '../../components/ui/Table/TableHeaderColumn';
import AssetClusterTableRow from "./AssetClusterTableRow";
import CardTitleHeader from "../../components/ui/Cards/CardTitleHeader";
import CloseButton from "../../components/ui/CloseButton/CloseButton";
import Signals from "../../../signals/Signals";
import { SystemFeatureToggle } from "../../../data/SystemFeatureToggle";
import Session from "../../../services/Session";
import Feature from "../../components/ui/Feature/Feature";
/**
 *
 */
var AssetClusterTableOverlay = /** @class */ (function (_super) {
    __extends(AssetClusterTableOverlay, _super);
    /**
     *
     * @param props
     */
    function AssetClusterTableOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { assetCollection: new AssetCollection(false) };
        _this.state.assetCollection.addAll(props.assets);
        _this.setTableRef = _this.setTableRef.bind(_this);
        _this.onTableScroll = _this.onTableScroll.bind(_this);
        _this.onSortClick = _this.onSortClick.bind(_this);
        return _this;
    }
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    AssetClusterTableOverlay.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _a = this.state, table = _a.table, tableContainer = _a.tableContainer;
        if (table) {
            if (tableContainer.scrollTop > table.offsetHeight) {
                table.scrollIntoView();
            }
        }
    };
    /**
     *
     */
    AssetClusterTableOverlay.prototype.render = function () {
        var assetCollection = this.state.assetCollection;
        var _a = this.props, intl = _a.intl, onZoom = _a.onZoom, clusterId = _a.clusterId, position = _a.position, showServiceEntries = _a.showServiceEntries;
        var user = Session.user;
        return React.createElement(Container, { className: "asset-cluster-table-overlay col-12 col-md-10 col-lg-8 col-xl-6 h-100 d-flex flex-column" },
            React.createElement(Card, { className: "card--full-height bg-white" },
                React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'asset.cluster.overlay.title' }, { count: assetCollection.filteredAndSorted.length }), isReversed: true }, onZoom ?
                    React.createElement("button", { className: "btn btn-white", onClick: function () {
                            onZoom(clusterId, position);
                            Signals.HideOverlay.dispatch();
                        } },
                        React.createElement("i", { className: "fe fe-zoom-in" })) : null),
                React.createElement("div", { ref: this.setTableRef, className: "table-container w-100 h-100 flex-fill", style: { backgroundColor: "#e5f0f7" } },
                    React.createElement(Table, { className: "table-sm table-striped table-responsive" },
                        React.createElement("thead", { className: "bg-white" },
                            React.createElement("tr", { onClick: this.onSortClick },
                                React.createElement(TableHeaderColumn, { labelId: "page.assets.table.column.id", sortBy: "id" }),
                                React.createElement(TableHeaderColumn, { labelId: "page.assets.table.column.make", sortBy: "make" }),
                                React.createElement(TableHeaderColumn, { labelId: "page.assets.table.column.model", sortBy: "model" }),
                                React.createElement(TableHeaderColumn, { labelId: "page.assets.table.column.serialnumber", sortBy: "serialNumber" }),
                                React.createElement(Feature, { hasAny: [SystemFeatureToggle.SERVICEFEATUREPACK], disabled: !showServiceEntries },
                                    React.createElement(TableHeaderColumn, { labelId: "page.assets.table.column.serviceentries", sortBy: "serviceEntries" })),
                                React.createElement(TableHeaderColumn, { labelId: "page.assets.table.column.labels", sortBy: "labels", className: "w-100", compact: false }),
                                React.createElement(TableHeaderColumn, { labelId: "page.assets.table.column.lastupdate", sortBy: "locationDateTime" }))),
                        React.createElement("tbody", null, assetCollection.filtered.length > 0 ?
                            assetCollection.filteredAndSorted.map(function (assetModel, index) {
                                return React.createElement(AssetClusterTableRow, { key: index + '-' + assetModel.id, assetModel: assetModel, showServiceEntries: showServiceEntries, compact: true });
                            }) : React.createElement(EmptyTableRow, { colSpan: 5 }))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    /**
     *
     * @param event
     */
    AssetClusterTableOverlay.prototype.onSortClick = function (event) {
        var assetCollection = this.state.assetCollection;
        var sort = assetCollection.sort;
        var fieldName = event.target.dataset.sort;
        var direction = sort.fieldName === fieldName ? sort.direction * -1 : 1;
        assetCollection.sort.update({ fieldName: event.target.dataset.sort, direction: direction });
        assetCollection.updateSortCache();
    };
    /**
     *
     */
    AssetClusterTableOverlay.prototype.onTableScroll = function () {
        var _a = this.state, thead = _a.thead, tableContainer = _a.tableContainer;
        thead.style.transform = 'translateY(' + tableContainer.scrollTop + 'px)';
        if (tableContainer.scrollTop < 5 && thead.classList.contains('box-shadow')) {
            thead.classList.remove('box-shadow');
        }
        if (tableContainer.scrollTop > 5 && !thead.classList.contains('box-shadow')) {
            thead.classList.add('box-shadow');
        }
    };
    /**
     *
     * @param ref
     */
    AssetClusterTableOverlay.prototype.setTableRef = function (ref) {
        if (ref) {
            var table = ref.querySelector('table');
            var thead = ref.querySelector('thead');
            this.setState({ table: table, thead: thead, tableContainer: ref });
            ref.addEventListener('scroll', this.onTableScroll);
        }
    };
    AssetClusterTableOverlay = __decorate([
        observer
    ], AssetClusterTableOverlay);
    return AssetClusterTableOverlay;
}(React.Component));
AssetClusterTableOverlay.contextType = ApplicationContext;
export default injectIntl(AssetClusterTableOverlay);
